export const message = {
    confirmDelete: 'Â¿Estas seguro de Eliminar este registro?',
    confirmUpdate: 'Â¿Estas seguro de Actualizar este registro?',
    confirmSave: 'Â¿Estas seguro de Guardar?',
    confirmState: 'Â¿Estas seguro de Cambiar Estado?',
    confirmDefault: 'Â¿Estas seguro de realizar la AcciÃ³n?',
};
